import React, { Component } from "react";
import CardInformasiPinjaman from "../../organism/pinjaman/CardInformasiPinjaman";
import CardData from "../../organism/pinjaman/PengajuanPinjaman/CardData";
import ModalWithTextbox from "../../organism/ModalWithTextbox";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import { GetDigisignPage, LoanDetail } from "../../../redux/actions/LoanDetail";
import { connect } from "react-redux";
import Loading from "../../../components/molecules/Loading";
import { Negotiate, RejectNego, AccNego, AccNegoV2 } from "../../../redux/actions/Negosiasi";
import RefreshToken from "../../../redux/actions/RefreshToken";
import LoanGrade from "../../../utils/actions/GetParameter";
import { REQ_DETAIL_LOAN, REQ_DETAIL_LOAN_DONE, SET_ERROR_STATE } from "../../../utils/constants/actionTypes";
import { GetDocs, RejectLoan, SignAgreement, SignAgreementNoDigisign } from "../../../redux/actions/LoanAgreement";
import { GLoanGrade } from "../../../config/api";
import ModalTTD from "../../organism/ModalTTD";
import Profil from "../../../redux/actions/Profil";

class PengajuanPinjamanDetil extends Component {
	_ismounted = false;
	constructor(props) {
		super(props);
		this.state = {
			statusBtn: [
				{ title: "Data Pinjaman", status: true, key: "DataPinjaman" },
				{ title: "Informasi Dokumen", status: false, key: "InformasiDokumen" },
				/*{ title: "Data Jaminan", status: false, key: "DataJaminan" },*/
				{ title: "Riwayat Negosiasi", status: false, key: "RiwayatNegosiasi" },
			],
			dataNegosiasi: { loanRate: "", provisionFeePercentage: "", provisionFee: "" },
			dataDetail: {},
			showModal: false,
			statusNextNego: false,
			modalProps: {
				title: "",
				content: ``,
				icon: "/img/icon/Warning-Big.png",
				actYes: {
					title: "KIRIM",
					action: () => {
						this.setState({ showModal: false });
					},
				},
				actNo: {
					title: "BATAL",
					action: () => {
						this.setState({ showModal: false });
					},
				},
				actClose: () => {
					this.setState({ showModal: false });
				},
			},
			memo: "",
			errMsg: null,
			success: false,
			loadingModal: false,
			LoanGrade: [],
			showModalSign: false,
			accDisclaimer: false,
		};
	}

	changeDisclaimer = () => {
		let disclaimer = this.state.accDisclaimer;
		this.setState({ accDisclaimer: !disclaimer });
	};

	resetValNego = () => {
		let { dataNegosiasi } = this.state;
		let { detail } = this.props.loanDetail;

		dataNegosiasi = { loanRate: detail.loanRate || "", provisionFeePercentage: detail.provisionFeePercentage || "", provisionFee: detail.provisionFee };
		dataNegosiasi.statusCompare = true;
		this.setState({ dataNegosiasi });
	};

	componentWillUnmount = () => {
		this._ismounted = false;
	};

	componentDidMount = () => {
		let { loanCode } = this.props.match.params;
		this._ismounted = true;
		LoanGrade(GLoanGrade, "null", (data, err) => {
			if (err) {
				this.props.SetError(err);
			} else {
				if (this._ismounted) {
					this.setState({ LoanGrade: data.loan.grades });
				}
			}
		});

		this.props.setTitlePage({
			title: "Pengajuan Pinjaman",
			breadcrumb: [
				{ name: "Beranda", url: "/dashboard", status: false },
				{ name: "Pengajuan Pinjaman", url: "/pengajuan-pinjaman", status: false },
				{ name: loanCode, url: "/#", status: true },
			],
		});
		this.setData();
	};

	setData = () => {
		let { loanCode } = this.props.match.params;
		if (this.props.ClientID) {
			this.props.getLoanDetail(this.props.ClientID, loanCode);

			if (!this.props.profileState) {
				this.props.GetProfile(this.props.ClientID);
			}
		}
	};

	onChangeDataNegosiasi = (key, value) => {
		let { dataNegosiasi } = this.state;
		let { detail } = this.props.loanDetail;

		value = value.replace(/[^\d\.]/g, "");
		if (key === "provisionFeePercentage") {
			dataNegosiasi.provisionFee = (detail.loanAmount * value) / 100;
		}
		dataNegosiasi[key] = value;
		if (dataNegosiasi.loanRate == detail.loanRate && dataNegosiasi.provisionFeePercentage == detail.provisionFeePercentage) {
			dataNegosiasi.statusCompare = true;
		} else {
			dataNegosiasi.statusCompare = false;
		}
		this.setState({ dataNegosiasi });
	};

	changeBtn = (index) => {
		let { statusBtn } = this.state;
		for (let i = 0; i < statusBtn.length; i++) {
			if (i === index) {
				statusBtn[i].status = true;
			} else {
				statusBtn[i].status = false;
			}
		}
		this.setState({ statusBtn });
	};

	nextNego = (status) => {
		let { statusNextNego } = this.state;
		statusNextNego = status;
		this.resetValNego();
		this.setState({ statusNextNego });
	};

	modalAjukanNego = () => {
		let { loanCode } = this.props.match.params;
		let { modalProps } = this.state;
		let setModalProps = {
			...modalProps,
			title: "Ajukan Negosiasi",
			content: `Anda hendak melakukan pengajuan negosiasi dengan kode ${loanCode}`,
			placeholder: "Masukan Catatan",
			contentSuccess: `Anda berhasil mengajukan negosiasi dengan kode ${loanCode}`,
			titleSuccess: "Pengajuan Negosiasi Berhasil",
			onChange: (val) => {
				this.setState({ memo: val });
			},
			actYes: {
				title: "KIRIM",
				action: () => {
					this.ajukanNego(loanCode);
				},
			},
			actNo: {
				title: "BATAL",
				action: () => {
					this.setState({ memo: "", showModal: false, errMsg: null });
				},
			},
		};
		this.setState({ modalProps: setModalProps, showModal: true });
	};

	modalAccNego = () => {
		let { loanCode } = this.props.match.params;
		let { modalProps } = this.state;
		let setModalProps = {
			...modalProps,
			title: "Setujui Pinjaman",
			content: `Anda hendak menyetujui negosiasi pinjaman dengan kode ${loanCode}`,
			placeholder: "Masukan Catatan",
			contentSuccess: `Anda berhasil menyetujui negosiasi pinjaman dengan kode ${loanCode}`,
			titleSuccess: "Pinjaman Telah Berhasil Disetujui",
			onChange: (val) => {
				this.setState({ memo: val });
			},
			actYes: {
				title: "KIRIM",
				action: () => {
					this.accNego(loanCode);
				},
			},
			actNo: {
				title: "BATAL",
				action: () => {
					this.setState({ memo: "", showModal: false, errMsg: null });
				},
			},
		};
		this.setState({ modalProps: setModalProps, showModal: true });
	};

	modalRjtLoan = () => {
		let { loanCode } = this.props.match.params;
		let { modalProps } = this.state;
		let { loanStatus } = this.props.loanDetail.detail;
		let setModalProps = {
			...modalProps,
			title: "Penolakan Pinjaman",
			content: `Anda hendak melakukan penolakan pinjaman dengan kode ${loanCode}`,
			placeholder: "Masukan Catatan",
			contentSuccess: `Penolakan pinjaman dengan kode ${loanCode} telah dilakukan.`,
			titleSuccess: "Penolakan Pinjaman Berhasil",
			onChange: (val) => {
				this.setState({ memo: val });
			},
			actYes: {
				title: "KIRIM",
				action: () => {
					loanStatus === "AP0" ? this.rjtNego(loanCode) : loanStatus === "AGR" && this.rjtLoan(loanCode);
				},
			},
			actNo: {
				title: "BATAL",
				action: () => {
					this.setState({ memo: "", showModal: false, errMsg: null });
				},
			},
		};
		this.setState({ modalProps: setModalProps, showModal: true });
	};

	rjtNego = (loanCode) => {
		let { memo } = this.state;
		this.setState({ loadingModal: true, errMsg: null });
		if (!memo) {
			this.setState({ errMsg: "Catatan tidak boleh kosong", loadingModal: false });
		} else {
			this.props.RefreshToken((ClientID) => {
				this.setState({ loadingModal: false });
				if (ClientID) {
					this.props.RejectNego(ClientID, loanCode, memo, (success) => {
						if (success) {
							this.setState({ success });
						}
					});
				}
			});
		}
	};

	rjtLoan = (loanCode) => {
		let { memo } = this.state;
		this.setState({ loadingModal: true, errMsg: null });
		if (!memo) {
			this.setState({ errMsg: "Catatan tidak boleh kosong", loadingModal: false });
		} else {
			this.props.RefreshToken((ClientID) => {
				this.setState({ loadingModal: false });
				if (ClientID) {
					this.props.RejectLoan(ClientID, loanCode, memo, (success) => {
						if (success) {
							this.setState({ success });
						}
					});
				}
			});
		}
	};

	accNego = (loanCode) => {
		let { memo } = this.state;
		this.setState({ loadingModal: true, errMsg: null });
		if (!memo) {
			this.setState({ errMsg: "Catatan tidak boleh kosong", loadingModal: false });
		} else {
			this.props.RefreshToken((ClientID) => {
				this.setState({ loadingModal: false });
				if (ClientID) {
					this.props.AccNego(ClientID, loanCode, memo, (success) => {
						if (success) {
							this.setState({ success });
						}
					});
				}
			});
		}
	};

	ajukanNego = (loanCode) => {
		let { memo, dataNegosiasi } = this.state;
		let data = { memo, loanRate: dataNegosiasi.loanRate, provisionFeePercentage: dataNegosiasi.provisionFeePercentage };
		this.setState({ loadingModal: true, errMsg: null, success: false });
		if (!memo) {
			this.setState({ errMsg: "Catatan tidak boleh kosong", loadingModal: false });
		} else {
			this.props.RefreshToken((ClientID) => {
				this.setState({ loadingModal: false });
				if (ClientID) {
					this.props.Negotiate(ClientID, loanCode, data, (success) => {
						if (success) {
							this.setState({ success });
						}
					});
				}
			});
		}
	};

	generateDoc = () => {
		const { loanCode } = this.props.match.params;
		const { picUID } = this.props.profileState.picDetail;
		const { isDigitalSignature } = this.props.loanDetail.detail;
		const { SetLoadingPage, SetLoadingPageDone } = this.props;

		SetLoadingPage();
		this.props.RefreshToken((ClientID) => {
			this.setState({ loadingModal: false });
			this.props.GetDocs(ClientID, loanCode, (dataSuccess) => {
				if (dataSuccess) {
					if (isDigitalSignature) {
						GetDigisignPage(ClientID, dataSuccess, picUID, (status, payload) => {
							console.log(status, payload);
							//window.open(payload, "Popup", "toolbar=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30");
							window.open(payload, "popUpWindow", "height=700, width=680, left=50, top=50, resizable=yes, scrollbars=yes, toolbar=no, menubar=no, location=no, directories=no, status=yes");
							SetLoadingPageDone();
						});
					} else {
						this.setState({ showModalSign: true });
						SetLoadingPageDone();
					}
				} else {
					SetLoadingPageDone();
				}
			});
		});
	};

	signAgreement = () => {
		let { loanCode } = this.props.match.params;
		let { documentNumber, fileUID } = this.props.loanAgreementState.docs;
		this.setState({ loadingModal: true, success: false });
		let data = {
			loanAgreementNumber: documentNumber,
			loanAgreementFileUID: fileUID,
		};
		this.props.RefreshToken((ClientID) => {
			if (ClientID) {
				this.props.SignAgreement(ClientID, loanCode, data, (status) => {
					if (status) {
						this.setState({ loadingModal: false, success: true });
					} else {
						this.setState({ loadingModal: false, success: false });
					}
				});
			}
		});
	};

	signAgreementNoDigisign = () => {
		let { loanCode } = this.props.match.params;
		this.setState({ loadingModal: true, success: false });

		this.props.RefreshToken((ClientID) => {
			if (ClientID) {
				this.props.SignAgreementNoDigisign(ClientID, loanCode, (status) => {
					if (status) {
						this.setState({ loadingModal: false, success: true });
					} else {
						this.setState({ loadingModal: false, success: false });
					}
				});
			}
		});
	};

	render() {
		let { statusBtn, dataNegosiasi, showModal, modalProps, statusNextNego, memo, errMsg, success, loadingModal, LoanGrade, showModalSign, accDisclaimer } = this.state;
		let { detail, loading } = this.props.loanDetail;
		let { negosiasiState, loanAgreementState, profileState } = this.props;
		return (
			<div>
				{detail && (
					<div className="row">
						<div className="col-md-4" style={{ padding: "0px 25px" }}>
							<CardInformasiPinjaman data={detail} />
						</div>
						<div className="col-md-8" style={{ padding: "0px 25px" }}>
							<CardData
								changeBtn={this.changeBtn}
								statusBtn={statusBtn}
								onChangeDataNegosiasi={this.onChangeDataNegosiasi}
								dataNegosiasi={dataNegosiasi || {}}
								dataDetail={detail}
								nextNego={this.nextNego}
								statusNextNego={statusNextNego}
								accNego={this.modalAccNego}
								rjtLoan={this.modalRjtLoan}
								ajukanNego={this.modalAjukanNego}
								resetValNego={this.resetValNego}
								LoanGrade={LoanGrade}
								generateDoc={this.generateDoc}
								profile={profileState}
							/>
						</div>
					</div>
				)}
				<Loading display={loading} />
				<ModalWithTextbox loading={negosiasiState.loading || loadingModal} closeSuccess={() => this.props.history.push("/pengajuan-pinjaman")} success={success} show={showModal} errMsg={errMsg} {...modalProps} value={memo} />
				{showModalSign && (
					<ModalTTD
						contentDoc={loanAgreementState}
						onClose={() => this.setState({ showModalSign: false })}
						closeSuccess={() => this.props.history.push("/pengajuan-pinjaman")}
						changeDisclaimer={this.changeDisclaimer}
						accDisclaimer={accDisclaimer}
						onClick={this.signAgreementNoDigisign}
						contentSuccess={`Proses penandatanganan telah berhasil, harap menunggu konfirmasi selanjutnya`}
						titleSuccess={"Proses Penandatanganan Berhasil"}
						success={success}
					/>
				)}
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		profileState: state.profileState.list,
		loanDetail: state.loanDetailState,
		negosiasiState: state.negosiasiState,
		loanAgreementState: state.loanAgreementState,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getLoanDetail: (ClientID, loanCode) => {
			dispatch(LoanDetail(ClientID, loanCode));
		},
		RejectNego: (ClientID, loanCode, memo, cb) => {
			dispatch(RejectNego(ClientID, loanCode, memo, cb));
		},
		RefreshToken: (cb) => {
			dispatch(RefreshToken(cb));
		},
		AccNego: (ClientID, loanCode, memo, cb) => {
			dispatch(AccNegoV2(ClientID, loanCode, memo, cb));
		},
		Negotiate: (ClientID, loanCode, data, cb) => {
			dispatch(Negotiate(ClientID, loanCode, data, cb));
		},
		SetError: (errMsg) => {
			dispatch({ type: SET_ERROR_STATE, payload: errMsg });
		},
		GetDocs: (ClientID, loanCode, cb) => {
			dispatch(GetDocs(ClientID, loanCode, cb));
		},
		RejectLoan: (ClientID, loanCode, memo, cb) => {
			dispatch(RejectLoan(ClientID, loanCode, memo, cb));
		},
		SignAgreement: (ClientID, loanCode, data, cb) => {
			dispatch(SignAgreement(ClientID, loanCode, data, cb));
		},
		SignAgreementNoDigisign: (ClientID, loanCode, cb) => {
			dispatch(SignAgreementNoDigisign(ClientID, loanCode, cb));
		},
		GetProfile: (ClientID) => {
			dispatch(Profil(ClientID));
		},
		SetLoadingPage: () => {
			dispatch({ type: REQ_DETAIL_LOAN });
		},
		SetLoadingPageDone: () => {
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
		},
	};
};

export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(PengajuanPinjamanDetil));
